// src/stores/userStore.js
import { defineStore } from 'pinia';
import { getUser, constantsGet } from '@/api/index'


export const useUserStore = defineStore('container', {
  state: () => ({
    // user
    userData: {
      userName: "",//昵称
      password: "",//密码
      mobile: "",
      nickName: "",
      idNumber: "",
      userIcon: "",
      inviteCode: '',
      bindingInviteCode: '',
      integralBalance: 0,   // 钱
      iconBalance: 0, //钻石
      userLevel: "",
      userLevelExp: '',
      userSteam: {
        steamUrl: ''
      },
    },
    // 玩法说明
    ruleDescData: {
      title: '',
      text: '文案文案文案文案文案文案文案文案文案文案',
      show: false
    },

    //支付弹框
    payPopShow: false,


    // 转场状态
    changePageShow: false,

  }),
  actions: {
    //  获取用户信息
    getUserInfo() {
      getUser().then(res => {
        this.userData = res.data //用户信息
        if (!res.data.mobile) {
          this.setBangDingPop(true)
        }
      })
    },

    // 玩法说明
    // open
    getRuleDesc(key, title) {
      // 网络请求
      constantsGet(key).then(res => {
        this.ruleDescData.title = title
        this.ruleDescData.text = res.data
        this.ruleDescData.show = true
        document.documentElement.style.overflow = "hidden";
      })
    },
    // close
    closeRuleDesc() {
      this.ruleDescData.show = false
      setTimeout(() => {
        this.ruleDescData.title = ''
        this.ruleDescData.text = ''
        document.documentElement.style.overflowY = "scroll";
      }, 500);
    },


    // 转场控制
    setChangePageShow(type) {
      this.changePageShow = type
    }

  }
});